import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icon/default_404@2x.png'
import _imports_1 from '@/assets/icon/default_loginfailed@2x.png'


const _withScopeId = n => (_pushScopeId("data-v-2d82dbd6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "auth" }
const _hoisted_2 = {
  key: 0,
  class: "auth_loading"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "正在登录，请稍后...", -1))
const _hoisted_4 = {
  key: 1,
  class: "auth_err"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "页面登录失败", -1))
const _hoisted_7 = {
  key: 2,
  class: "auth_permissions"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: ""
}, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "您的账号授权登录失败，请联系管理员", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", null, "点击返回EDGP", -1))
const _hoisted_11 = [
  _hoisted_8,
  _hoisted_9,
  _hoisted_10
]

import { ref, onMounted } from 'vue'
    import { useRouter } from 'vue-router'
    import { useStore } from 'vuex'
    import { lingyangLogin, getUserInfo } from '@/apis/index'
    import { Toast } from "vant"
  
    
export default /*#__PURE__*/_defineComponent({
  setup(__props) {

    const store = useStore()
    const router = useRouter()
    let status = ref(1)
    let data: any = ref({})

    const login = () => {
        status.value = 1
        lingyangLogin(data.value)
            .then(async(res) => {
                if (res.code === 200) {
                    let info: any = await getUserInfo()
                    if (info.code === 200) {
                        await store.commit('setUserInfo', info.data)
                        await store.commit('setCompany', 'noLogin')
                        await store.dispatch('getMenuList', 2)
                        await router.replace('/workbench')
                    } else {
                        Toast.fail(info.message)
                        status.value = 2
                    }
                } else {
                    Toast.fail(res.message)
                    status.value = 2
                }
            })
            .catch(err => {
                Toast.fail(err.message)
                status.value = 2
            })
    }

    onMounted(() => {
        store.commit('setEntrance', 'DD')
        let query = window.location.href.split('?')[1].split('&')
        query.forEach(item => {
            let subQuery = item.split('=')
            data.value[subQuery[0]] = subQuery[1]
        })
        login()
    })
  
return (_ctx: any,_cache: any) => {
  const _component_van_loading = _resolveComponent("van-loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(status) == 1)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_van_loading, {
            size: "50px",
            color: "#1989fa"
          }),
          _hoisted_3
        ]))
      : _createCommentVNode("", true),
    (_unref(status) == 2)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _hoisted_5,
          _hoisted_6,
          _createElementVNode("button", { onClick: login }, "点击重试")
        ]))
      : _createCommentVNode("", true),
    (_unref(status) == 3)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, _hoisted_11))
      : _createCommentVNode("", true)
  ]))
}
}

})